import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here
import Config from "../../Config.jsx";

import Localization from "../../Localization.jsx"
import LocaleOverviewHotspotContent from "./LocaleOverviewHotspotContent.jsx"

import {
  Card,
  Grid,
  List,
  Avatar,
  Group,
  Text,
} from '@mantine/core';

import {
  IconMapPin,
} from '@tabler/icons-react';

class LocaleOverviewHotspot extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
    };
    autoBind(this);
  }

  component(componentData) {
    return (
      <><span><br /></span>
      <div style={{ border: "2px solid #5F5F5F", borderRadius: "10px" }}>
        <Group key={componentData.id} align="flex-start" wrap="nowrap" p="sm">
          <Avatar radius="xl">
            <IconMapPin size={20} />
          </Avatar>
          {/* minWidth:0 is required: a flex item defaults to min-width:auto (its
              min-content width), and overflow-wrap:break-word does NOT shrink
              min-content, so one long unbreakable string — e.g. a percent-encoded
              reference URL — pushes this item wider than the bordered box and the
              text spills outside it. overflowWrap must stay LAST: wordWrap is the
              legacy alias of the same property, kept as the fallback for engines
              without "anywhere", and whichever is declared last wins. */}
          <div style={{ wordWrap: "break-word", overflowWrap: "anywhere", flex: 1, minWidth: 0 }}>
            <LocaleOverviewHotspotContent root={this.props.root} parent={this} contentData={componentData} />
          </div>
        </Group>
      </div></>
    );
  }

  render() {
    return (
      <div>
        {/*< Divider variant="middle" style={{backgroundcolor:"#00FF00"}}/ >*/}
        <Card style={{margin:"0 0 16px 0"}} shadow="none" withBorder>
          <Text fw={600} size="lg" mb="sm">
            {this.props.hotspotData.name}
          </Text>
          <List listStyleType="none">
            {this.props.hotspotData.component_list.map( (row, i) => {
              return (
                <React.Fragment key={row.id != null ? row.id : i}>
                  {this.component(row)}
                </React.Fragment>
              );
            })}
          </List>
        </Card>
      </div>
    )
  }
}

export default LocaleOverviewHotspot;
